// Models
import { createSetSelfAssessmentFormStoreDefaultModel } from './set-self-assessment-form/set-self-assessment-form.store'

const setSelfAssessmentFormModels = {
  setSelfAssessmentForm: createSetSelfAssessmentFormStoreDefaultModel(),
}

export { setSelfAssessmentFormModels }
